import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors['neutral-30']};
  border-radius: 4px;
  padding: 2px 6px 2px 6px;
`;

export const Text = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: ${(props) => props.theme.colors['neutral-100']};
`;
